import { Spinner } from "react-bootstrap";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        height: "100vh",
      }}
    >
      <Spinner animation="border" variant="dark" />
    </div>
  );
};

export default Loader;
